import React, { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/UserTypes.css';
import '../Styles/PopupModal.css';
import { useSidebar } from '../Layout/SidebarContext';

const BankDetails = () => {

  const { isConfigOpen } = useSidebar();

  const [bankDetails, setBankDetails] = useState([
    {
      id: 1,
      bankName: 'ABC Bank',
      accountNumber: '1234567890',
      aBARoutingNumber: '893423456',
      address: 'P.O. Box 1800 Saint Paul, Minnesota 55101-0800  ',
      createdBy: 'Admin',
      createdDate: '01-Jan-2023',
      editedBy: 'Admin',
      editedDate: '15-Nov-2024',
    },
    {
      id: 1,
      bankName: 'XYZ Bank',
      accountNumber: '0987654321',
      aBARoutingNumber: '893423456',
      address: 'P.O. Box 1800 Saint Paul, Minnesota 55101-0800  ',
      createdBy: 'Admin',
      createdDate: '01-Jan-2023',
      editedBy: 'Admin',
      editedDate: '15-Nov-2024',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [newBank, setNewBank] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleAddNew = () => {
    setNewBank({});
    setIsModalOpen(true);
  };

  const handleSaveNew = () => {
    if (newBank.bankName && newBank.accountNumber) {
      setBankDetails([
        ...bankDetails,
        {
          ...newBank,
          id: bankDetails.length + 1,
          createdBy: 'Admin',
          createdDate: new Date().toLocaleDateString(),
          editedBy: 'Admin',
          editedDate: new Date().toLocaleDateString(),
        },
      ]);
      setIsModalOpen(false);
    }
  };

  const handleEditBank = (index) => {
    setNewBank(bankDetails[index]);
    setEditIndex(index);
    setIsEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    const updatedDetails = [...bankDetails];
    updatedDetails[editIndex] = {
      ...newBank,
      editedBy: 'Admin',
      editedDate: new Date().toLocaleDateString(),
    };
    setBankDetails(updatedDetails);
    setIsEditModalOpen(false);
  };

  const handleDeleteBank = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    setBankDetails(bankDetails.filter((_, index) => index !== deleteIndex));
    setConfirmDelete(false);
  };

  const filteredBankDetails = bankDetails.filter(
    (bank) =>
      bank.bankName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      bank.accountNumber.includes(searchTerm)
  );

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className="heading">
        <h2>Manage Bank Details</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search Bank Details"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <table className="user-types-table">
        <thead>
          <tr>
            <th>
              <MdAdd size={24} color="#1e3c72" onClick={handleAddNew} />
            </th>
            <th>Bank Name</th>
            <th>Account Number</th>
            <th>ABA Routing Number</th>
            <th>Address</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Edited By</th>
            <th>Edited Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredBankDetails.map((bank, index) => (
            <tr key={bank.id}>
              <td>
                <FaEdit
                  size={15}
                  style={{ cursor: 'pointer', color: '#00bfa5' }}
                  onClick={() => handleEditBank(index)}
                />
                <FaTrash
                  size={15}
                  color="#f44336"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDeleteBank(index)}
                />
              </td>
              <td>{bank.bankName}</td>
              <td>{bank.accountNumber}</td>
              <td>{bank.aBARoutingNumber}</td>
              <td>{bank.address}</td>
              <td>{bank.createdBy}</td>
              <td>{bank.createdDate}</td>
              <td>{bank.editedBy}</td>
              <td>{bank.editedDate}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal for Adding/Editing */}
      {(isModalOpen || isEditModalOpen) && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{isModalOpen ? 'Add New Bank Detail' : 'Edit Bank Detail'}</h3>
            <input
              type="text"
              placeholder="Bank Name"
              value={newBank.bankName || ''}
              onChange={(e) => setNewBank({ ...newBank, bankName: e.target.value })}
            />
            <input
              type="text"
              placeholder="Account Number"
              value={newBank.accountNumber || ''}
              onChange={(e) =>
                setNewBank({ ...newBank, accountNumber: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="IFSC Code"
              value={newBank.ifscCode || ''}
              onChange={(e) => setNewBank({ ...newBank, ifscCode: e.target.value })}
            />
            <input
              type="text"
              placeholder="Branch"
              value={newBank.branch || ''}
              onChange={(e) => setNewBank({ ...newBank, branch: e.target.value })}
            />
            <div className="modal-actions">
              <button onClick={isModalOpen ? handleSaveNew : handleSaveEdit}>
                Save
              </button>
              <button onClick={() => (isModalOpen ? setIsModalOpen(false) : setIsEditModalOpen(false))}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this bank detail?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={() => setConfirmDelete(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankDetails;
